/* import __COLOCATED_TEMPLATE__ from './success.hbs'; */
import Component from '@glimmer/component';
import styles from './success.module.scss';

export default class SiteWaitlistIntakeSuccess extends Component {
  styles = styles;
}
